import React, { useState } from 'react';
import { Phone, Clock, Car, ChevronDown, ChevronUp } from 'lucide-react';

const TaxiServices = () => {
  const [expandedContent, setExpandedContent] = useState(false);
  const [expandedFAQs, setExpandedFAQs] = useState({});

  const popularPackages = [
  { destination: 'Ludhiana to Nainital', image: "https://images.unsplash.com/photo-1622298522852-1433fa950fe8", alt: 'Scenic view of Nainital lake surrounded by mountains' },
  { destination: 'Ludhiana to Delhi', image: "https://images.unsplash.com/photo-1669635543126-86878b29c268", alt: 'India Gate monument in Delhi with blue sky' },
  { destination: 'Ludhiana to Chandigarh', image: "https://img.rocket.new/generatedImages/rocket_gen_img_18497d434-1766311204682.png", alt: 'Rock Garden sculptures in Chandigarh' },
  { destination: 'Ludhiana to Gurugram', image: "https://img.rocket.new/generatedImages/rocket_gen_img_128a5d5d8-1767907241850.png", alt: 'Modern skyline of Gurugram with corporate buildings' },
  { destination: 'Ludhiana to Dehradun', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b204476e-1768083987688.png", alt: 'Dehradun valley with lush green hills' },
  { destination: 'Ludhiana to Manali', image: "https://images.unsplash.com/photo-1670521820867-965fa9c18610", alt: 'Snow-capped mountains in Manali with pine trees' },
  { destination: 'Ludhiana to Shimla', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1accbbf5b-1767793338191.png", alt: 'Colonial architecture and Mall Road in Shimla' },
  { destination: 'Ludhiana to Amritsar', image: "https://images.unsplash.com/photo-1597114981569-379a03be6f5a", alt: 'Golden Temple illuminated at night in Amritsar' },
  { destination: 'Ludhiana to Dharamshala', image: "https://images.unsplash.com/photo-1632648028106-0c58cab7bc38", alt: 'Dharamshala monastery with mountain backdrop' }];



  const features = [
  {
    icon: <Clock className="w-12 h-12 text-blue-600" />,
    title: '24 * 7 Support',
    description: 'We accompany you both during and after the journey. at your beck and call If assistance is required.'
  },
  {
    icon: <Car className="w-12 h-12 text-blue-600" />,
    title: 'Clean and Hygienic Car',
    description: 'Highlight your commitment to regular and thorough cleaning of the vehicles. This can include disinfection of commonly touched surfaces.'
  }];


  const faqs = [
  {
    question: 'Is the taxi service available 24/7?',
    answer: 'Yes, our taxi service operates 24/7 to ensure that you can book a taxi at any time that suits your travel needs.'
  },
  {
    question: 'How easy is it to book taxi?',
    answer: 'Booking a taxi with Advait Tour and Travels is extremely easy. You can book through our website, mobile app, or by calling our 24/7 customer support number.'
  },
  {
    question: 'What if my travel plans change?',
    answer: 'We understand that plans can change. You can modify or cancel your booking by contacting our customer support team. Cancellation charges may apply based on our policy.'
  },
  {
    question: 'Can I get the contact details of the driver before my journey?',
    answer: 'Yes, you will receive the driver\'s contact details and vehicle information before your scheduled pickup time.'
  },
  {
    question: 'How can I make the payment for the taxi service?',
    answer: 'We accept multiple payment methods including cash, credit/debit cards, UPI, and online banking for your convenience.'
  },
  {
    question: 'What details will I receive once I book a taxi?',
    answer: 'After booking, you will receive a confirmation with booking ID, driver details, vehicle information, pickup time, and fare details.'
  },
  {
    question: 'Can I specify any special requirements during the booking process?',
    answer: 'Yes, you can mention any special requirements such as child seats, extra luggage space, or accessibility needs during the booking process.'
  },
  {
    question: 'How can I inquire about the availability of a taxi for a specific date and time?',
    answer: 'You can check availability by visiting our website or calling our customer support team with your preferred date and time.'
  },
  {
    question: 'What types of vehicles are available for booking?',
    answer: 'We offer a wide range of vehicles including sedans, SUVs, tempo travellers, and luxury Force Urbania vehicles to suit different group sizes and preferences.'
  },
  {
    question: 'Are cabs readily available at Ludhiana airport?',
    answer: 'Yes, our cabs are readily available at Ludhiana airport 24/7. You can also pre-book for guaranteed availability.'
  },
  {
    question: 'How do I book a taxi from Ludhiana airport?',
    answer: 'You can book a taxi from Ludhiana airport through our website, app, or by calling our customer support. Pre-booking is recommended for faster service.'
  }];


  const toggleFAQ = (index) => {
    setExpandedFAQs((prev) => ({
      ...prev,
      [index]: !prev?.[index]
    }));
  };

  return (
    <section className="py-12 sm:py-14 md:py-16 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-3 sm:px-4">
        {/* Main Heading */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-6 sm:mb-8 text-orange-600 px-4">
          Taxi services in Ludhiana
        </h2>

        {/* Value Proposition */}
        <div className="max-w-5xl mx-auto mb-8 sm:mb-10 md:mb-12">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-center mb-4 sm:mb-6 px-4">
            Value for satisfaction, value for money, and value for time – the principles defining{' '}
            <span className="text-yellow-400 bg-yellow-200 px-2">Advait Tour and Travels!</span>
          </h3>
          
          <div className="text-gray-700 space-y-3 sm:space-y-4 text-sm sm:text-base md:text-lg leading-relaxed px-4">
            <p>
              Traveling to and from Ludhiana or this pristine city can be quite cumbersome. While public transports are abundant, they often need to offer the comfort and satisfaction people seek. So, if you want to make the most out of your travel experience, Advait Tour and Travels is your one-stop destination for taxi services in Ludhiana. Our online cab booking Ludhiana service is customer-centric, punctual, and affordable. We ensure to meet the needs of our customers in every sense and redefine comfort and satisfaction for every one of them. This may be why we have become one of the best taxi service providers in the city. Additionally, with our airport taxi hire service now open 24X7, no one has to get worried about traveling to and from the airport.
            </p>
            <p className="font-semibold">
              So, look no further and avail our taxi services in Ludhiana to travel with no impending, worrisome thoughts clouding your mind!
            </p>
          </div>
        </div>

        {/* Why Ride Section */}
        <div className="max-w-5xl mx-auto mb-8 sm:mb-10 md:mb-12 px-4">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-blue-600 mb-4 sm:mb-6">
            Why ride with Advait Tour and Travels Taxi Service in Ludhiana?
          </h3>
          
          <div className={`text-gray-700 space-y-3 sm:space-y-4 text-sm sm:text-base md:text-lg leading-relaxed overflow-hidden transition-all duration-500 ${expandedContent ? 'max-h-full' : 'max-h-80 sm:max-h-96'}`}>
            <div className="space-y-3">
              <div className="flex gap-3">
                <span className="text-blue-600 font-bold">●</span>
                <div>
                  <span className="font-semibold">Punctual:</span> Our taxi services in Ludhiana are known for punctuality. In other words, we always stick to the time mentioned when booking, with no unnecessary delay. Even if our drivers get delayed due to unforeseen circumstances, we notify our customers immediately to prevent any inconvenience.
                </div>
              </div>
              
              <div className="flex gap-3">
                <span className="text-blue-600 font-bold">●</span>
                <div>
                  <span className="font-semibold">Experienced and reliable:</span> Advait Tour and Travels has offered regular, outstation, and airport taxi services in Ludhiana for a decade. So, we can vouch for the reliability of our online cab service, whether in terms of passenger safety or route choice.
                </div>
              </div>
              
              <div className="flex gap-3">
                <span className="text-blue-600 font-bold">●</span>
                <div>
                  <span className="font-semibold">Real-time tracking:</span> We ensure each cab is integrated with GPS technology for real-time monitoring. So, our customers can know the current locations of our vehicles and travel safely with no worry.
                </div>
              </div>
              
              <div className="flex gap-3">
                <span className="text-blue-600 font-bold">●</span>
                <div>
                  <span className="font-semibold">Epitome fleet condition:</span> Whether you want to book an airport taxi in Ludhiana or a regular cab for traveling around the city, each car provided is in its optimal condition. Our fleet is maintained and managed correctly to ensure that on-road safety is not compromised by any means.
                </div>
              </div>
            </div>

            {expandedContent &&
            <>
                <h4 className="text-xl font-bold text-gray-800 mt-6 mb-3">
                  Book Affordable & Safe Cabs in Ludhiana - Reliable Services
                </h4>
                <p>
                  Are you worried about spending hundreds for online cab booking in Ludhiana? If yes, do not worry anymore! At Advait Tour and Travels, we offer reliable cab services to everyone who wishes to travel comfortably and safely. Additionally, our online cab booking Ludhiana fares are dynamic as the amount depends on numerous factors, including:
                </p>
                <div className="space-y-2 ml-3">
                  <div className="flex gap-3">
                    <span className="text-blue-600 font-bold">●</span>
                    <span>Distance between the destinations</span>
                  </div>
                  <div className="flex gap-3">
                    <span className="text-blue-600 font-bold">●</span>
                    <span>Airport hires</span>
                  </div>
                  <div className="flex gap-3">
                    <span className="text-blue-600 font-bold">●</span>
                    <span>Booking hours</span>
                  </div>
                  <div className="flex gap-3">
                    <span className="text-blue-600 font-bold">●</span>
                    <span>Facilities asked for</span>
                  </div>
                </div>
                <p>
                  Nonetheless, our online cab booking Ludhiana services are affordable. We even offer discounts and other offers to keep everyone engaged in our services and excite them whenever they want to book a taxi in the city.
                </p>

                <h4 className="text-xl font-bold text-gray-800 mt-6 mb-3">
                  Get an Airport taxi service in Ludhiana at Your Doorstep Anytime.
                </h4>
                <p>
                  With our cab booking airport service now available 24X7, you do not have to worry about getting the best travel option. Our cabs will reach your doorstep at the right time so that you can catch your flight with no hassle. Our airport taxi hire service is most demanded because our fleet is available round the clock. So, whether it is an early morning or a late night flight, we will make the journey more manageable and comfortable.
                </p>

                <h4 className="text-xl font-bold text-gray-800 mt-6 mb-3">
                  Cab Booking In Ludhiana With Advait Tour and Travels
                </h4>
                <p>
                  If you want to book an airport taxi in Ludhiana or any other destination, Advait Tour and Travels is here to offer you the best deals. With years of industry experience, we understand people's needs when looking for a reliable cab service. We ensure all our drivers are licensed, experienced, and take their jobs seriously. Furthermore, we also provide cars in their best condition, with clean and hygienic seats, air conditioners, stereo systems, and many other such features.
                </p>

                <h4 className="text-xl font-bold text-gray-800 mt-6 mb-3">
                  Cabs to Destinations near Ludhiana
                </h4>
                <p>
                  Finding the best airport taxi service Ludhiana to and from other destinations can be cumbersome. So, we offer on-time and 24X7 cabs to customers traveling to cities nearby Ludhiana. They can avail of our cabs from the airport itself with prior booking to avoid the struggles of standing in long queues.
                </p>

                <h4 className="text-xl font-bold text-gray-800 mt-6 mb-3">
                  Taxi fare in Ludhiana
                </h4>
                <p>
                  If you are worried about the fares of our regular, outstation, or airport taxi service Ludhiana, you must let go of all these thoughts. Our fares depend on the distance between the destinations, the booking time, and the hours the cab is booked. We have different travel packages to help you save more on outstation travels in our cabs. Experience ultimate comfort, safety and reliability by booking with Advait Tour and Travels. Trust us for all your cab booking airport travel needs in Ludhiana and get set for a pleasant journey!
                </p>
              </>
            }
          </div>

          <div className="flex justify-center mt-4 sm:mt-6">
            <button
              onClick={() => setExpandedContent(!expandedContent)}
              className="bg-yellow-400 hover:bg-yellow-500 active:bg-yellow-600 text-black font-semibold px-6 sm:px-8 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg flex items-center gap-2 transition-all duration-300 shadow-lg touch-manipulation">

              Read More {expandedContent ? <ChevronUp className="w-4 h-4 sm:w-5 sm:h-5" /> : <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5" />}
            </button>
          </div>
        </div>

        {/* Popular Cab Packages */}
        <div className="max-w-6xl mx-auto mb-12 sm:mb-14 md:mb-16 px-4">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6 sm:mb-8">
            Popular Cab Packages from Ludhiana
          </h3>
          <p className="text-center text-gray-600 mb-6 sm:mb-8 text-sm sm:text-base md:text-lg">
            Some of the popular packages we offer for our online cab services in Ludhiana are:
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
            {popularPackages?.map((pkg, index) =>
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer touch-manipulation">

                <div className="h-40 sm:h-44 md:h-48 overflow-hidden">
                  <img
                  src={pkg?.image}
                  alt={pkg?.alt}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />

                </div>
                <div className="p-3 sm:p-4">
                  <h4 className="text-base sm:text-lg font-semibold text-gray-800 text-center">
                    {pkg?.destination}
                  </h4>
                </div>
              </div>
            )}
          </div>
          
          <p className="text-center text-gray-700 mt-6 sm:mt-8 text-sm">
            So, now you can easily book our cabs with affordable packages to these destinations anytime. You can also choose Advait Tour and Travels for cab booking airport from Ludhiana to these most common outstation locations.
          </p>
        </div>

        {/* Features & Benefits */}
        <div className="max-w-6xl mx-auto mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-center text-orange-600 mb-4">
            Features & Benefits of Taxi-Booking
          </h3>
          <p className="text-center text-gray-600 mb-12 text-base md:text-lg max-w-4xl mx-auto">
            In today's emerging tech world human life is getting multiple services at doorstep right from online food delivery to taxi booking through online Booking. People prefer services that have the less interaction & everything on their smart device.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {features?.map((feature, index) =>
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">

                <div className="flex flex-col items-center text-center">
                  <div className="mb-4">{feature?.icon}</div>
                  <h4 className="text-xl font-bold text-gray-800 mb-3">
                    {feature?.title}
                  </h4>
                  <p className="text-gray-600 text-base">
                    {feature?.description}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="max-w-4xl mx-auto mb-16">
          <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">
            Frequently Asked Question (FAQ)
          </h3>
          
          <div className="space-y-4">
            {faqs?.map((faq, index) =>
            <div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden">

                <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200">

                  <span className="font-semibold text-gray-800 pr-4">
                    {faq?.question}
                  </span>
                  {expandedFAQs?.[index] ?
                <ChevronUp className="w-5 h-5 text-blue-600 flex-shrink-0" /> :

                <ChevronDown className="w-5 h-5 text-blue-600 flex-shrink-0" />
                }
                </button>
                
                {expandedFAQs?.[index] &&
              <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                    <p className="text-gray-700">{faq?.answer}</p>
                  </div>
              }
              </div>
            )}
          </div>
        </div>

        {/* 24/7 Contact Support */}
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl shadow-2xl p-8 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              We're here for you 24/7!
            </h3>
            <p className="text-lg mb-6">Give us a call anytime</p>
            <a
              href="tel:+917998666660"
              className="inline-flex items-center gap-3 bg-white text-blue-600 font-bold text-xl md:text-2xl px-8 py-4 rounded-full hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">

              <Phone className="w-6 h-6" />
              +91-7998666660
            </a>
          </div>
        </div>
      </div>
    </section>);

};

export default TaxiServices;